import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.number.constructor";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import { validImageFileName, readableFileSizeFromBytes as readableFileSizeUtil, randomInt } from '../../../utils/vuex';
export default {
  name: 'CoreDtwinAttachments',
  props: {
    accept: {
      type: String,
      default: '*/*'
    },
    source: {
      type: String,
      default: 'digitaltwin'
    },
    selectableImages: {
      type: Boolean,
      default: true
    },
    selectedAttachments: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    attachments: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false
    },
    apiVersion: {
      type: Number,
      default: 1,
      required: false
    }
  },
  data: function data() {
    return {
      attachmentsInternal: [],
      showPreviewDialog: false,
      imagePreviewUrl: '',
      errorMessage: '',
      uploads: [],
      queue: []
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['snackbar', 'inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme'])), {}, {
    buttons: function buttons() {
      return [{
        title: this.$i18n_t('DigitalTwin.DigitalTwin.attachmentButtonAdd'),
        icon: 'fal fa-plus',
        action: 'addItem',
        valid: !this.disabled && this.accept !== ''
      }];
    },
    maxNumberAttachments: function maxNumberAttachments() {
      return 10;
    },
    maxBytePerAttachment: function maxBytePerAttachment() {
      switch (this.source) {
        case 'devicetype':
          return 20000000;
        // 20 Megabyte

        default:
          return 10000000;
        // 10 Megabye
      }
    }
  }),
  watch: {
    attachments: function attachments() {
      this.attachmentsInternal = this.attachments || [];
    }
  },
  mounted: function mounted() {
    this.attachmentsInternal = this.attachments || [];
  },
  methods: {
    // isItemSelectable(item) {
    //   // possibility to select image icons for twins
    //   return this.selectableImages && this.source === 'digitaltwin' && validImageFileName(item.name);
    // },
    isImage: function isImage(item) {
      return this.selectableImages && this.source === 'digitaltwin' && validImageFileName(item.name);
    },
    itemSelectionStatus: function itemSelectionStatus(item) {
      return this.selectedAttachments.indexOf(item.id) >= 0;
    },
    itemSelected: function itemSelected(item) {
      if (this.source === 'digitaltwin') {
        if (validImageFileName(item.name)) {
          this.$emit('image-selected', item);
        }
      }

      this.$emit('item-selected', item);
    },
    itemDeselected: function itemDeselected(item) {
      // this is also called if a item is deleted, so make sure only to emit actually selected deleted items
      if (this.itemSelectionStatus(item)) {
        if (this.source === 'digitaltwin') {
          if (validImageFileName(item.name)) {
            this.$emit('image-deselected', item);
          }
        }

        this.$emit('item-deselected', item);
      }
    },
    imagePreviewLoaded: function imagePreviewLoaded() {// @TODO: implement visual loading cue and hide it and show loaded image here
    },
    addItem: function addItem() {
      this.$refs.attachmentInput.click();
    },
    readableFileSizeFromBytes: readableFileSizeUtil,
    fileInputClicked: function fileInputClicked() {
      this.errorMessage = '';
    },
    fileInputChanged: function fileInputChanged() {
      var files = this.$refs.attachmentInput.files;

      if (!this.validateFileNumberLimit(files) || !this.validateFileSizeLimit(files)) {
        this.$refs.attachmentInput.value = '';
        return;
      } // if there is a listener set, call that one and let it handle/manipulate the files before uploading


      if (this.$listeners && this.$listeners['files:custom-selection']) {
        this.$emit('files:custom-selection', Array.from(this.$refs.attachmentInput.files));
      } else {
        this.queue = Array.from(this.$refs.attachmentInput.files);
        this.addFilesToUploads();
      }

      this.$refs.attachmentInput.value = '';
    },
    validateFileNumberLimit: function validateFileNumberLimit(files) {
      if (files && Array.from(files).length + this.attachmentsInternal.length > this.maxNumberAttachments) {
        this.errorMessage = this.$i18n_t('DigitalTwin.DigitalTwin.attachmentErrorLimitExceeded', {
          attachtmentMaxNumber: this.maxNumberAttachments
        });
        return false;
      }

      return true;
    },
    validateFileSizeLimit: function validateFileSizeLimit(files) {
      var _this = this;

      if (files) {
        var rejectedFile = Array.from(files).filter(function (file) {
          return file.size >= _this.maxBytePerAttachment;
        });

        if (rejectedFile.length > 0) {
          this.errorMessage = this.$i18n_t('DigitalTwin.DigitalTwin.attachmentErrorFileTooBig', {
            attachtmentMaxSize: this.readableSizeFromBytes(this.maxBytePerAttachment)
          });
          return false;
        }
      }

      return true;
    },
    addFilesToUploads: function addFilesToUploads() {
      var file = this.queue.shift();

      if (file) {
        this.uploads.push({
          id: "".concat(Date.now()).concat(randomInt(2000)),
          name: file.name,
          size: file.size,
          file: file
        });
      }
    },
    previewHandler: function previewHandler(fileUrl) {
      this.imagePreviewUrl = fileUrl;
      this.showPreviewDialog = true;
    },
    updateHandler: function updateHandler(attachment) {
      if (attachment) {
        this.uploads = this.uploads.filter(function (upload) {
          return upload.id !== attachment.item.id;
        });
        var attachmentItem = {};

        if (this.source === 'devicetype') {
          attachmentItem = {
            name: attachment.item.name,
            size: attachment.item.size,
            storagePath: attachment.fileId,
            type: attachment.item.file.type
          };
        } else {
          attachmentItem = {
            id: attachment.fileId,
            name: attachment.item.name,
            size: attachment.item.size
          };
        }

        this.attachmentsInternal = this.attachmentsInternal.concat(attachmentItem);
        this.$emit('update', this.attachmentsInternal);
      }

      this.addFilesToUploads();
    },
    removeHandler: function removeHandler(file) {
      this.errorMessage = '';
      var removedItem = {};

      if (this.source === 'devicetype') {
        removedItem = this.attachmentsInternal.find(function (item) {
          return item.storagePath !== file.storagePath;
        });
        this.attachmentsInternal = this.attachmentsInternal.filter(function (item) {
          return item.storagePath !== file.storagePath;
        });
      } else {
        removedItem = this.attachmentsInternal.find(function (item) {
          return item.id !== file.id;
        });
        this.attachmentsInternal = this.attachmentsInternal.filter(function (item) {
          return item.id !== file.id;
        });
      }

      this.itemDeselected(removedItem || {});
      this.$emit('update', this.attachmentsInternal);
    },
    readableSizeFromBytes: function readableSizeFromBytes(bytes) {
      if (typeof bytes !== 'number' || isNaN(bytes)) {
        return '';
      }

      var exponent;
      var unit;
      var neg = bytes < 0;
      var units = ['B', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

      if (neg) {
        bytes = -bytes;
      }

      if (bytes < 1) {
        return "".concat((neg ? '-' : '') + bytes, " B");
      }

      exponent = Math.min(Math.floor(Math.log(bytes) / Math.log(1000)), units.length - 1);
      bytes = (bytes / Math.pow(1000, exponent)).toFixed(2);
      unit = units[exponent];
      return "".concat((neg ? '-' : '') + bytes, " ").concat(unit);
    }
  }
};